interface UsageRatioBarProps {
  /** 百分比数值，如 50 表示 50% */
  ratio: number;
  className?: string;
  /** 进度条宽度，默认 w-24 */
  barClassName?: string;
}

function getUsageRatioTone(ratio: number) {
  // <50 主题色；50–80 蓝色；80–95 警告色；≥95 危险色
  if (ratio >= 95) return { bar: 'bg-red-500', text: 'text-red-600' };
  if (ratio > 80) return { bar: 'bg-amber-500', text: 'text-amber-600' };
  if (ratio >= 50) return { bar: 'bg-blue-500', text: 'text-blue-600' };
  return { bar: 'bg-primary-500', text: 'text-primary-600' };
}

export default function UsageRatioBar({
  ratio,
  className = '',
  barClassName = 'w-24',
}: UsageRatioBarProps) {
  const value = Number.isFinite(ratio) ? ratio : 0;
  const barWidth = Math.max(0, Math.min(100, value));
  const tone = getUsageRatioTone(value);

  return (
    <div className={`inline-flex items-center gap-2 min-w-0 ${className}`}>
      <div
        className={`${barClassName} h-1.5 rounded-full bg-background-200 overflow-hidden shrink-0`}
        role="progressbar"
        aria-valuenow={Math.round(barWidth)}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className={`h-full rounded-full transition-[width] ${tone.bar}`}
          style={{ width: `${barWidth}%` }}
        />
      </div>
      <span className={`text-xs font-semibold tabular-nums whitespace-nowrap ${tone.text}`}>
        {value.toFixed(2)}%
      </span>
    </div>
  );
}
